// @flow

import React, { type Node } from 'react';
import styled, { type StyledComponent } from 'styled-components';

import { VetInfoConstants } from '@rover/app/js/constants/translationConstants';
import type { Pet } from '@rover/react-lib/types';
import { Paragraph } from '@rover/react-lib/components/typography';
import FormGroup from '@rover/react-lib/components/formFields/FormGroup';
import Textarea from '@rover/react-lib/components/formFields/Textarea';
import Button, { ButtonType } from '@rover/react-lib/components/buttons/Button';

type Props = {
  pet: Pet,
  hasMultiplePets: boolean,
  handleVetInfoChange: (veterinaryInformation: string) => void,
  value: string,
  isEditing: boolean,
  toggleEditing: (pet: Pet) => void,
};

const UpdateButton: StyledComponent<{}> = styled(Button)`
  padding: 0;
`;

const PetVetInfo = ({
  pet,
  hasMultiplePets,
  handleVetInfoChange,
  value,
  isEditing,
  toggleEditing,
}: Props): Node => {
  const inputId = `vet-info-${pet.id}`;

  return (
    <FormGroup>
      {hasMultiplePets && <label htmlFor={inputId}>{pet.name}</label>}
      {isEditing ? (
        <Textarea autoExpand onChange={handleVetInfoChange} value={value} id={inputId} />
      ) : (
        <Paragraph size="200" marginBottom="1x">
          {value}
        </Paragraph>
      )}
      {!isEditing && (
        <UpdateButton buttonType={ButtonType.TEXT} onClick={() => toggleEditing(pet)}>
          {VetInfoConstants.updateButton}
        </UpdateButton>
      )}
    </FormGroup>
  );
};

export default PetVetInfo;



// WEBPACK FOOTER //
// ../react-lib/src/pages/conversations/EmergencyFormPage/components/VetInfo/PetVetInfo.jsx